import { render, staticRenderFns } from "./ChangeRetailer.vue?vue&type=template&id=f57b4918"
import script from "./ChangeRetailer.vue?vue&type=script&lang=js"
export * from "./ChangeRetailer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports